/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Service_Add_GgdInputs */

const vi_carrier_service_add_ggd = /** @type {(inputs: Carrier_Service_Add_GgdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận hàng tại bưu cục`)
};

/**

* @param {Carrier_Service_Add_GgdInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_service_add_ggd = /** @type {((inputs?: Carrier_Service_Add_GgdInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Service_Add_GgdInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_service_add_ggd(inputs)
});